import type { EntityId, FamilySituation } from "../types/parentPortal";

export const buildFamilySituationMutationRequest = (
  familyId: EntityId,
  familySituation: FamilySituation | null | undefined,
) => ({
  entityType: "FAMILY",
  action: "UPDATE",
  entityId: familyId,
  payload: {
    familyId,
    familySituation: familySituation || "MARRIED",
  },
});
